<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.customer.booking_notes' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

    <div class="row">
        <div class="col-lg-12 input-control">
            <hub-text-area [(ngModel)]="clientNotes" placeholder="{{ 'bikeshop.workshop.jobcard.customer.booking_notes_place_holder' | translate }}"
                [autofocus]="true"></hub-text-area>
        </div>
    </div>

</div>
<div class="modal-footer-container">
    <div class="button-container">
        <hub-button [text]="'bikeshop.shop_profile.collections.buttons.add' | translate"
            [style]="'secondary'" 
            (buttonClick)="addnotes()" [size]="'xl'"></hub-button>
    </div>
    <div class="short-cut-container">
        <div>
            <span><daz-icon [name]="'enter'" [size]="'18px'"
                    [color]="'#6B728C'"></daz-icon></span>{{'bikeshop.workshop.jobcard.quote.to_save_and_close' |
            translate}}
        </div>
    </div>
</div>